import Lottery from '../../pages/lottery/index.vue'
import PlayVideo from '../../pages/video/PlayVideo'
import luckDraw from '../../pages/luckDraw/index'

// content 页面路由：统一公开路径及路由名称，组件和 meta 保持不变。
const routes = [
  { path: '/games/lottery', name: 'games-lottery', component: Lottery, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/videos/play', name: 'videos-play', component: PlayVideo, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
  { path: '/games/lucky-draw', name: 'games-lucky-draw', component: luckDraw, meta: { title: '' } , pathToRegexpOptions: { sensitive: true }},
]

export default routes
